import { buildSelector } from '@/shared/lib/store';

export const [useViewerEmail] = buildSelector(
    (state) => state.viewer?.data?.email,
);
